import { HttpClient, HttpContext, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { BaseService } from '@/core/api/base-service';
import { ApiConfiguration } from '@/core/api/api-configuration';
import { FormacaoRequest, ProrrogarPrazoDiplomaResponse } from '@/core/api/sicom-api/registro/medico/formacao/formacao.model';
import { RlTipoFormacaoDiplomaResponse } from '@/core/api/sicom-api/registro/medico/formacao/formacao-tipos.model';
import { PosGraduacaoResponse } from '@/core/api/sicom-api/registro/medico/formacao/pos-graduacao.model';
import { Pessoa } from '@/shared/models/pessoa-info.model';
import { environment } from '@env/environment';
import { SICOM_PATHS } from 'src/sicom-paths';

@Injectable({ providedIn: 'root' })
export class FormacaoService extends BaseService {
    constructor(config: ApiConfiguration, http: HttpClient) {
        super(config, http, environment.apis.apiSicom);
    }
    readonly PATH_FORMACAO = SICOM_PATHS.registro.medico.formacao;
    readonly PATH_TIPOS_DIPLOMAS = SICOM_PATHS.registro.medico.formacao;
    readonly PATH_POS_COMPROVANTE = SICOM_PATHS.registro.medico.posComprovante;
    readonly PATH_POS_GRADUACAO = SICOM_PATHS.registro.medico.posGraduacao;

    buscar(params: Pessoa, context?: HttpContext): Observable<FormacaoRequest[]> {
        const q = new HttpParams().set('id', String(params.id)).set('uf', String(params.uf));
        return this.http.get<FormacaoRequest[]>(this.PATH_FORMACAO, { params: q, context });
    }

    // Listar tipos de diploma por Tipo de Formação
    listarDiplomasPorTipoFormacao(idTipoFormacao: number, context?: HttpContext): Observable<RlTipoFormacaoDiplomaResponse[]> {
        return this.http.get<RlTipoFormacaoDiplomaResponse[]>(`${this.PATH_TIPOS_DIPLOMAS}/${idTipoFormacao}/diplomas`, { context });
    }

    listarComprovantePosGraduacao(context?: HttpContext): Observable<RlTipoFormacaoDiplomaResponse[]> {
        return this.http.get<RlTipoFormacaoDiplomaResponse[]>(this.PATH_POS_COMPROVANTE, { context });
    }

    // Listar Pós-Graduações do médico
    listarPosGraduacoes(params: Pessoa, context?: HttpContext): Observable<PosGraduacaoResponse[]> {
        const q = new HttpParams().set('id', String(params.id)).set('uf', String(params.uf));
        return this.http.get<PosGraduacaoResponse[]>(this.PATH_POS_GRADUACAO, { params: q, context });
    }

    // Salvar formação de Graduação
    // POST /api/v1/cadastro/medico/formacao?tipoInscricao=E
    salvarFormacao(formacao: any, tipoInscricao?: string, context?: HttpContext): Observable<void> {
        let params = new HttpParams();
        if (tipoInscricao) params = params.set('tipoInscricao', tipoInscricao);
        return this.http.post<void>(this.PATH_FORMACAO, formacao, { params, context });
    }

    // Criar ou atualizar Pós-Graduação
    // POST /api/v1/cadastro/medico/pos-graduacao
    salvarPosGraduacao(body: PosGraduacaoResponse | any, context?: HttpContext): Observable<void> {
        return this.http.post<void>(this.PATH_POS_GRADUACAO, body, { context });
    }

    removerFormacao(params: Pessoa & { tipoFormacao: number }, context?: HttpContext): Observable<void> {
        const q = new HttpParams().set('id', String(params.id)).set('uf', String(params.uf)).set('tipoFormacao', String(params.tipoFormacao));
        return this.http.delete<void>(this.PATH_FORMACAO, { params: q, context });
    }

    removerPosGraduacao(params: Pessoa & { coCursoEspecializacao: number }, context?: HttpContext): Observable<void> {
        const q = new HttpParams().set('id', String(params.id)).set('uf', String(params.uf)).set('coCursoEspecializacao', String(params.coCursoEspecializacao));
        return this.http.delete<void>(this.PATH_POS_GRADUACAO, { params: q, context });
    }

    // Prorrogar prazo para apresentacao do diploma (Graduacao)
    // POST /api/v1/cadastro/medico/formacao/prorrogar-prazo-diploma
    prorrogarPrazoDiploma(pessoa: Pessoa, context?: HttpContext): Observable<ProrrogarPrazoDiplomaResponse> {
        const q = new HttpParams().set('id', String(pessoa.id)).set('uf', String(pessoa.uf));
        return this.http.post<ProrrogarPrazoDiplomaResponse>(`${this.PATH_FORMACAO}/prorrogar-prazo-diploma`, {}, { params: q, context });
    }
}
